export const mockClients = [
  {
    id: 'cl1',
    name: 'Ana García',
    email: 'ana.garcia@example.com',
    phone: '555-1234',
    address: 'Calle Falsa 123, Ciudad',
    lastPurchase: '2024-07-10'
  },
  {
    id: 'cl2',
    name: 'Luis Pérez',
    email: 'luis.perez@example.com',
    phone: '555-5678',
    address: 'Avenida Siempre Viva 45, Pueblo',
    lastPurchase: '2024-06-20'
  },
  {
    id: 'cl3',
    name: 'María López',
    email: 'maria.lopez@example.com',
    phone: '555-9012',
    address: 'Plaza Mayor 7, Villa',
    lastPurchase: '2024-07-01'
  }
];

export const mockProducts = [
  {
    id: 'prod1',
    name: 'Camiseta Básica Algodón',
    category: 'Camisetas',
    price: 19.99,
    stock: 150,
    sku: 'CMB001',
    imageUrl: 'https://via.placeholder.com/150/ADD8E6/000000?text=Camiseta'
  },
  {
    id: 'prod2',
    name: 'Pantalón Vaquero Slim Fit',
    category: 'Pantalones',
    price: 49.99,
    stock: 80,
    sku: 'PVSF002',
    imageUrl: 'https://via.placeholder.com/150/87CEEB/000000?text=Vaquero'
  },
  {
    id: 'prod3',
    name: 'Vestido Floral Verano',
    category: 'Vestidos',
    price: 35.50,
    stock: 45,
    sku: 'VFV003',
    imageUrl: 'https://via.placeholder.com/150/FFB6C1/000000?text=Vestido'
  },
  {
    id: 'prod4',
    name: 'Sudadera con Capucha',
    category: 'Sudaderas',
    price: 29.99,
    stock: 120,
    sku: 'SDC004',
    imageUrl: 'https://via.placeholder.com/150/90EE90/000000?text=Sudadera'
  }
];

export const mockOrders = [
  {
    id: 'ord1',
    clientId: 'cl1',
    clientName: 'Ana García',
    date: '2024-07-10',
    status: 'Completado',
    total: 69.98,
    items: [
      { productId: 'prod1', name: 'Camiseta Básica Algodón', quantity: 1, price: 19.99 },
      { productId: 'prod2', name: 'Pantalón Vaquero Slim Fit', quantity: 1, price: 49.99 }
    ]
  },
  {
    id: 'ord2',
    clientId: 'cl2',
    clientName: 'Luis Pérez',
    date: '2024-06-20',
    status: 'Pendiente',
    total: 35.50,
    items: [
      { productId: 'prod3', name: 'Vestido Floral Verano', quantity: 1, price: 35.50 }
    ]
  },
  {
    id: 'ord3',
    clientId: 'cl3',
    clientName: 'María López',
    date: '2024-07-01',
    status: 'Enviado',
    total: 49.98,
    items: [
      { productId: 'prod1', name: 'Camiseta Básica Algodón', quantity: 2, price: 19.99 },
      { productId: 'prod4', name: 'Sudadera con Capucha', quantity: 1, price: 29.99 }
    ]
  }
];